import * as RadPopover from '@radix-ui/react-popover'
import React from 'react'
import styled from 'styled-components'

import { SmileIcon } from '@blade/ui-kit'

import { WALLET_TRACKER_EMOJIS } from '../../model'

type AddWalletTrackerDialogEmojiProps = {
  open: boolean
  emoji: string
  container: HTMLDivElement | undefined
  onSetEmoji: (emoji: string) => void
  onOpenChange: (open: boolean) => void
}

export const AddWalletTrackerDialogEmoji: React.FC<
  AddWalletTrackerDialogEmojiProps
> = ({ open, emoji, container, onSetEmoji, onOpenChange }) => {
  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <RadPopover.Anchor asChild>
        <Trigger onClick={() => onOpenChange(!open)} aria-checked={open}>
          {emoji === '' ? <SmileIcon size={20} /> : <Emoji>{emoji}</Emoji>}
        </Trigger>
      </RadPopover.Anchor>
      <RadPopover.Portal container={container}>
        <Content side="bottom" align="start">
          <Arrow />
          {WALLET_TRACKER_EMOJIS.map((emoji) => (
            <Item
              key={emoji}
              onClick={() => {
                onSetEmoji(emoji)
                onOpenChange(false)
              }}
            >
              {emoji}
            </Item>
          ))}
        </Content>
      </RadPopover.Portal>
    </Root>
  )
}

const Root = styled(RadPopover.Root)``

const Trigger = styled(RadPopover.Trigger)`
  background: transparent;
  display: grid;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  border: none;

  display: grid;
  margin-inline: -4px;
  width: 20px;

  > svg {
    color: var(--text-8);
  }
`

const Content = styled(RadPopover.Content)`
  background: var(--background-3);
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 10px 6px 8px;
  border-radius: 8px;
  gap: 8px;
  margin-top: 6px;
  border-radius: 8px;
  backdrop-filter: blur(40px);
  margin-left: -10px;
`

const Item = styled.span`
  cursor: pointer;
  font-size: 12px;
  background: transparent;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  transition: all 0.1s ease-in-out;
  &:hover {
    background: var(--primary-9);
  }
`

const Arrow = styled(RadPopover.Arrow)`
  fill: var(--background-3);
  margin-left: -10px;
  margin-top: -1px;
`

const Emoji = styled.span`
  font-size: 14px;
  margin-top: 4px;
`
